import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function initConfirm(token, params) {

    return Api.put(REQUEST_URLS.COMPANY_APPROVAL.INIT_CONFIRM, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default initConfirm;